import { CALL_SORTED_API } from 'gwx-voyager-components';
import Schema from './opportunities.schema';

const opportunityRequestTypes = [
	'OPPORTUNITIES_REQUEST',
	'OPPORTUNITIES_SUCCESS',
	'OPPORTUNITIES_FAILURE'
];

/**
 * Dispatches an action that fetches the data for missed opportunities.
 *
 * @param {string} communityId
 * @param {string} start - start date epoch
 * @param {string} end - end date epoch
 * @param {object} query
 */
const fetchOpportunities = (communityId,
	startDate, endDate, addressFilter, query) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: opportunityRequestTypes,
		endpoint: 'opportunities',
		schema: Schema.OPPORTUNITIES,
		query: {
			...query,
			communityId,
			startDate,
			endDate,
			addressFilter
		},
		mapActionToStateKey: 'opportunities'
	}
});

const ProviderActivationStatusTypes = [
	'ACTIVATION_STATUS_REQUEST', 
	'ACTIVATION_STATUS_SUCCESS', 
	'ACTIVATION_STATUS_FAILURE'
];

/**
 * Dispatches an action that updates activation status and fetches the data for missed opportunities.
 *
 * @param {string} communityId
 * @param {string} start - start date epoch
 * @param {string} end - end date epoch
 * @param {string} addressFilter
 * @param {string} activationStatus
 * @param {object} query
 */
 const updateActivationStatus = (npi, communityId,
	startDate, endDate, addressFilter, activationStatus, query) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: ProviderActivationStatusTypes,
		endpoint: `opportunities/${npi}`,
		schema: Schema.OPPORTUNITIES,
		method: 'PUT',
		query: {
			...query,
			communityId,
			startDate,
			endDate,
			addressFilter,
			activationStatus
		},
		mapActionToStateKey: 'opportunities'
	}
});

const receiveOpportunityCount = (count) => ({
	type: 'RECEIVE_OPPORTUNITY_COUNT',
	count
});

export { fetchOpportunities as default, updateActivationStatus, receiveOpportunityCount };
